// config.user.getRights / config.user.getCameras return ONE [serial, ...values]
// row PER server — an eView CONTROLLER returns its own row plus a row for every
// member NVR. Callers want THIS server's values, so they must select the row by
// serial, not by position.
//
// The old code took result[1][0] (the first row) and, for cameras, stripped a
// hardcoded 256. That broke two ways:
//   1. On an eView controller a member row can sort first and be EMPTY for a
//      non-super user (whose ACL row exists only on the controller), so [0]
//      yielded no rights / no cameras (Playback hidden, single-cam nav dead).
//      Superusers were immune (every row is full).
//   2. On any NVR whose serial != 256, the `!== 256` camera filter leaked the
//      real serial into the camera list as a phantom camera id.
//
// selectServerValues picks the row whose leading element matches bSerial, then
// drops that leading serial. This mirrors how MacView (Rights.swift) and
// dview-java (Rights.java) key rights by serial.
//
// When the serial matches no row it FAILS SAFE rather than guessing:
//   - Exactly one row  -> use it. A single-server response is unambiguous, so a
//     0/unknown bSerial still resolves correctly.
//   - Multiple rows, no match -> return empty. This happens only when bSerial is
//     unknown (0) — e.g. a transient getStartup fault left servingSerial unset —
//     and the caller's no-access gate then DENIES. Never pick an arbitrary row
//     here: on an eView controller that would authorize the user from another
//     NVR's ACL row (grant rights on the wrong box, skipping the noremote gate).
//     Deny-and-relogin is the safe trade for a rare transient fault.
export const selectServerValues = (rows, bSerial) => {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  let row = null;
  if (bSerial) {
    row = rows.find(r => Array.isArray(r) && r[0] === bSerial);
  }
  if (!row && rows.length === 1 && Array.isArray(rows[0])) {
    row = rows[0]; // single-server: no ambiguity, no wrong-server risk
  }
  return Array.isArray(row) ? row.slice(1) : [];
};
